export const API_URL = 'https://api.farabazaar.ir';
export const FRONT_URL = "https://company.farabazaar.ir";
export const MASTER = '2zxqxZ1KUsLdlVGts7WQATgAV4GIcLmO';
export default ({ signal = null, route, token = false, method, body, contentType = true }) =>
  new Promise((resolve, reject) => {
    const headers = { authorization: token ? token : null };
    headers["Accept-Language"] = "fa";
    if (contentType) {
      headers['Content-Type'] = 'application/json';
      headers['Accept'] = 'application/json';
    }
    fetch(`${API_URL}/api/v1${route}`, {
      signal,
      headers,
      method: method,
      body: body ? body : null
    })
      .then(async res => {
        try {
          if (res.status >= 200 && res.status < 300) {
            resolve(await res.json());
          } else {
            reject(await res.json());
          }
        } catch (err) {
          if (res.status >= 200 && res.status < 300) {
            resolve(res);
          } else {
            reject(res);
          }
        }
      })
      .catch(reject);
  });
